import { defineStore } from 'pinia'

export const useComponentStore = defineStore({
  id: 'components',
  state: () => ({
    includeComponents: [
      'tab',
      'myStudy',
      'myTraining',
      'myCollect',
      'myPublish',
      'ExamList',
      'trainingDetail',
      'shopIndex',
      'communitySearchPage'
    ] as string[]
  }),
  actions: {
    setIncludeComponents(includeComponents: string[]) {
      this.includeComponents = includeComponents
    }
  },
  getters: {
    getIncludeComponents(): string[] {
      return this.includeComponents
    }
  },
  persist: true
})
